// TileNode contains all the layers of a tile on the map. The actual
// tile picture being drawn is handled in the other tile components
// such as GearTile, and TileNode uses these as well as TileWalls and
// stars and robots to create a full tile.

import TileActionResult from 'app/src/engine/action-results/TileActionResult';
import Star from 'app/src/engine/Star';
import Tile from 'app/src/engine/tiles/Tile';
import { useGameStateContext } from 'app/src/game/GameStateContext';
import StarNode from 'app/src/game/map/StarNode';
import TileWalls from 'app/src/game/map/tiles/TileWalls';
import * as React from 'react';

type Props = {
	row: number;
	col: number;
	tile: Tile;

	star?: Star | null;
};

export default function TileNode({ row, col, tile, star }: Props): React.ReactElement | null {
	const { gameStateStore } = useGameStateContext();

	const tilePlugin = Array.from(gameStateStore.gamePlugins).find((gamePlugin) =>
		gamePlugin.providesNodeForTile(tile),
	);

	if (!tilePlugin) {
		throw new Error('Could not find plugin for tile.');
	}

	const actionResults = ((gameStateStore.currentActionResultSet &&
		gameStateStore.currentActionResultSet
			.filter((a) => a instanceof TileActionResult)
			.filter((a: TileActionResult) => a.location.row === row && a.location.col === col)) ||
		null) as TileActionResult[] | null;

	return (
		<div className="TileNode">
			{tilePlugin.getTileNode(tile, row, col, actionResults, () =>
				gameStateStore.completeAnimation(),
			)}
			{star && <StarNode row={row} col={col} />}
			<TileWalls walls={tile.walls} />
		</div>
	);
}
